import React from 'react'
const PageContainer:any = (props:any) => {
  return (
    <div className="db-page-wrap">
      { props.children }
    </div>
  );
}

export default PageContainer
